import { render, staticRenderFns } from "./CorrespAuthor.vue?vue&type=template&id=127d1ea9&"
import script from "./CorrespAuthor.vue?vue&type=script&lang=js&"
export * from "./CorrespAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports